import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const currencies = ["EUR", "USD", "GBP", "CHF", "AUD", "AED", "INR"];

export function Availability({ availability, availabilityComment, saveAvailability }) {
  const [isEditing, setIsEditing] = useState(false);
  const [expertAvailability, setExpertAvailability] = useState("");
  const [expertAvailabilityComment, setExpertAvailabilityComment] = useState("");
	const [time, setTime] = useState("");

  useEffect(() => {
    setExpertAvailability(availability);
    setExpertAvailabilityComment(availabilityComment);
		const formattedTime = convertDateObject(availability);
		setTime(formattedTime);
  }, [availability, availabilityComment]);

  const handleSave = () => {
    saveAvailability({
			availability: expertAvailability,
			availabilityComment: expertAvailabilityComment,
			
    });
    setIsEditing(false);
  };

	// handle cancel action
  const handleCancel = () => {
    setExpertAvailability(availability);
		setExpertAvailabilityComment(availabilityComment);
    setIsEditing(false);
  };

  // Function to convert event date and time to readable object
  function convertDateObject(date) {
    const formatterDate = new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    const time = new Date(date);

    const parts = formatterDate.formatToParts(time);
    const weekday = parts.find(p => p.type === 'weekday').value;
    const day = parts.find(p => p.type === 'day').value;
    const month = parts.find(p => p.type === 'month').value;
    const year = parts.find(p => p.type === 'year').value;

    return {
      weekday,
      day,
      month,
      year,
    };
  };

  return (
    <div className={`bg-white rounded-xl p-6 relative transition-all duration-300 ${isEditing ? "glow-burst glow-hold" : "shadow"}`}>
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold mb-2">{!isEditing ? 'Availability' : 'Edit Availability'}</h3>

        {!isEditing ? (
          <button
            className="absolute top-5 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none py-1 px-2 rounded-full transition"
            onClick={() => setIsEditing(true)}
            title="Edit Rates"
          >
            <i className="fa-solid fa-pencil" />
          </button>
        ) : (
          <div className="absolute top-5 right-6 flex gap-2">
            <button
              className="text-gray-500 hover:text-black focus:outline-none py-1 px-2.5 rounded-full hover:bg-gray-200 transition"
              onClick={handleSave}
              title="Save"
            >
              <i className="fa-solid fa-floppy-disk" />
            </button>
            <button
              className="text-gray-500 hover:text-black focus:outline-none py-1 px-2.5 rounded-full hover:bg-gray-200 transition"
              onClick={handleCancel}
              title="Cancel"
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </div>
        )}
      </div>

      <AnimatePresence mode="wait">
        {!isEditing ? (
          <motion.div
            key="rates-view"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden flex flex-col gap-1 text-sm"
          >
            <p>📅 Available from {`${time.weekday}, ${time.month} ${time.day}, ${time.year}`}</p>
            <p>💬 {availabilityComment || 'No availability comment'}</p>
          </motion.div>
        ) : (
          <motion.div
            key="rates-edit"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden flex flex-col gap-2 text-sm"
          >
            <div className="flex flex-col gap-2">
              <input
                type="date"
                value={expertAvailability ? new Date(expertAvailability).toISOString().split("T")[0] : ""}
                onChange={(e) => setExpertAvailability(e.target.value)}
                className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-1 bg-white"
              />
              <input
                type="text"
                value={expertAvailabilityComment !== 'No availability comment' ? expertAvailabilityComment : ""}
                onChange={(e) => setExpertAvailabilityComment(e.target.value)}
                placeholder="Availability comment"
                className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-1 bg-white"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Glow animation */}
      <style>
        {`
          @keyframes glowBurst {
            0% {
              box-shadow: 0 0 0px 0px rgba(54, 85, 97, 0);
            }
            30% {
              box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6);
            }
            100% {
              box-shadow: 0 0 15px 3px rgba(54, 85, 97, 0.6);
            }
          }

          .glow-burst {
            animation: glowBurst 0.8s ease-out forwards;
            border-radius: 0.75rem;
          }

          .glow-hold {
            box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6);
            border-radius: 0.75rem;
          }
        `}
      </style>
    </div>
  );
}